(function () {
  function updateCountdown(el) {
    var end = new Date(el.dataset.date).getTime();
    var now = Date.now();
    var diff = end - now;
    if (diff <= 0) {
      el.textContent = '00:00:00';
      return false;
    }
    var d = Math.floor(diff / 86400000);
    var h = Math.floor((diff % 86400000) / 3600000);
    var m = Math.floor((diff % 3600000) / 60000);
    var s = Math.floor((diff % 60000) / 1000);
    var timeStr =
      String(h).padStart(2, '0') + ':' +
      String(m).padStart(2, '0') + ':' +
      String(s).padStart(2, '0');
    el.textContent = d > 0 ? d + 'day ' + timeStr : timeStr;
    return true;
  }

  function initDisplayPeriod() {
    var els = document.querySelectorAll('.displayPeriod');
    var now = Date.now();
    els.forEach(function (el) {
      var start = new Date(el.dataset.start).getTime();
      var end = new Date(el.dataset.end).getTime();
      if (now >= start && now < end) {
        el.style.display = '';
      } else {
        el.style.display = 'none';
      }
    });
  }

  function initCountdowns() {
    var spans = document.querySelectorAll('.countdown[data-date]');
    if (!spans.length) return;
    spans.forEach(function (span) { updateCountdown(span); });
    setInterval(function () {
      spans.forEach(function (span) { updateCountdown(span); });
    }, 1000);
  }

  initDisplayPeriod();
  initCountdowns();
})();
